import { render, staticRenderFns } from "./ChamberDelete.vue?vue&type=template&id=7a98c340&scoped=true&"
import script from "./ChamberDelete.vue?vue&type=script&lang=js&"
export * from "./ChamberDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a98c340",
  null
  
)

export default component.exports